import { Component, inject } from '@angular/core'
import { LayoutService } from '../layout.service'
import { AuthService } from '../../../services/auth.service'
import { Router } from '@angular/router'
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { ɵNzTransitionPatchDirective } from 'ng-zorro-antd/core/transition-patch';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.sass',
    imports: [
        NzIconDirective,
        ɵNzTransitionPatchDirective,
        NzButtonComponent,
        NzWaveDirective,
    ]
})
export class HeaderComponent {
  protected layoutService = inject(LayoutService)
  protected isCollapsed = this.layoutService.isCollapsed
  private router = inject(Router)
  private authService = inject(AuthService)

  protected get login() {
    return localStorage.getItem('login')
  }

  protected logout() {
    this.authService.clearTokens()
    this.router.navigate(['/login']).then()
  }
}
